import Button from "@/Components/Button/Button";
import Icon from "@/Components/Icon/Icon";
import { memo, type RefObject } from "react";
import { ButtonGroupProps } from "./types";
import useButtonGroupHook from "./useButtonGroupHook";
import { cn } from "@/shared/utils/cn";

const ButtonGroup = ({
  options,
  selected,
  buttonType = "submit",
  size = "small",
  label,
}: ButtonGroupProps) => {
  const { toggle, close, expended, ref } = useButtonGroupHook();
  const active = options.filter((option) => option.disabled !== true);
  const notGrouped = active.filter((option) => option.group);
  const grouped = active.filter((option) => !option.group);
  const onNavClick = (cb) => {
    close();
    cb();
  };
  return (
    <div ref={ref as RefObject<HTMLDivElement>} className="relative">
      {label && <div className="mb-4 font-semibold">{label}</div>}
      <div className="inline-flex max-w-full overflow-x-auto">
        {grouped.map(({ label, id, onClick }) => (
          <div key={id} className="mr-1">
            <Button
              className={cn(
                "whitespace-nowrap",
                selected === undefined
                  ? "bg-primary"
                  : id === selected
                    ? "bg-primary"
                    : "bg-disabled"
              )}
              onClick={onClick}
              size={size}
              type={buttonType}
            >
              {label}
            </Button>
          </div>
        ))}
        {notGrouped.length !== 0 && (
          <Button
            className="flex items-center"
            onClick={() => toggle()}
            size="small"
          >
            <Icon className="h-4 w-4 fill-white" variants="carrotDown" />
          </Button>
        )}
      </div>
      <div
        className={cn(
          "absolute z-999999999999999 w-full translate-y-1 shadow-[0px_0px_15px_0px_rgba(0,0,0,0.28)]",
          expended ? "block" : "hidden"
        )}
      >
        {notGrouped.map(({ label, id, onClick }, i, arr) => (
          <div
            key={id}
            className={i + 1 === arr.length ? "" : "border-b-4 border-white"}
          >
            <Button
              className="w-full cursor-pointer border-none text-left"
              onClick={() => onNavClick(onClick)}
              size="small"
            >
              {label}
            </Button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default memo(ButtonGroup);
